import $ from 'jquery';
import Collapsible from './collapsible';

var $collapsibles = $('.collapsible');

if ($collapsibles.length) {
    $collapsibles.each(function (index, item) {
        new Collapsible(item); // eslint-disable-line no-new
    });
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/components/collapsible/collapsibleBootstrap.js
 **/